import { getTemplateKey } from "./workflows";
import { buildTemplateVars, getTemplateMessage, renderTemplate } from "./templateEngine";
import { getTemplatesSnapshot } from "./templateStore";

export function formatSubject(pdf) {
  // Formats the subject line in pdf email tool box

  let { pdfType, subjectPrefix = "", isPaid = false, timesheet: ts, sendBoth } = pdf;

  let reference = ts?.refNumber || ts?.worksOrderNumber || "no_ref";
  let flat = ts?.flat ? `(${ts.flat?.replace("/", ".")})` : "";
  let addressLine = ts?.address ? `- ${ts.address} ${flat}` : "";
  let customerName = ts?.authorisedBy ? `- ${ts.authorisedBy}` : "";
  let paid = isPaid ? " (PAID)" : "";
  let both = sendBoth ? " and PAID" : "";

  // HES Quote no. 551 - 232 Main St (1.1) - Paul Henderson.pdf
  let formattedSubject = `HES${subjectPrefix} ${pdfType} ${reference}${paid}${both} ${addressLine} ${customerName}`;
  return formattedSubject;

  // return `HES ${pdfType} ${ts.refNumber || "no_ref"} ${
  //   showAddressInSubject
  //     ? `${ts.address ? `- ${ts.address}` : ""} ${
  //         ts.flat ? `(${ts.flat?.replace("/", ".")})` : ""
  //       }`
  //     : ""
  // }`;
}

export function formatAsFilename(text) {
  let formattedFilename = text.replace(/ [\\/\\\\:*?"<>|]/g, "");

  if (!formattedFilename) return "HES_FILE";
  return formattedFilename;
}

export function formatMessage(pdfState) {
  let { showReview = false, isPaid = null, pdfType, timesheet, amount, addressLine, workflowKey } =
    pdfState;

  let { refNumber, authorisedBy: name, vatMode, jobDetails } = timesheet;

  let firstName = getFirstName(name);

  let options = {
    refNumber,
    showReview,
    amount,
    name: firstName,
    workflowKey,
    addressLine,
    vatMode,
    jobDetails,
  };

  let emailType = pdfType;

  if (isPaid) {
    emailType = "Paid";
  }

  let emailMessage = getPdfEmailText(emailType, options);

  // console.log("Formatted Email Message", emailMessage);
  return emailMessage;
}

// Renders the message for a given (emailType, options) combination by looking up the
// editable template text (Firestore override, or the built-in default - see
// templateEngine.js / defaultTemplates.js) and substituting {{placeholders}}. The actual
// wording lives as data now, not here - this just resolves which template applies and
// fills it in.
export function getPdfEmailText(emailType, options) {
  let { workflowKey, vatMode } = { ...options };

  if (!workflowKey) return "";
  if (emailType !== "Quote" && emailType !== "Invoice" && emailType !== "Paid") return "";

  let templateKey = getTemplateKey(workflowKey, emailType, vatMode);
  let rawTemplate = getTemplateMessage(templateKey, getTemplatesSnapshot());
  let vars = buildTemplateVars(options);

  return renderTemplate(rawTemplate, vars);
}

export function calculateMaterialsLine({ itemRefPrice = 0, quantity = 0, priceWithAddOns }) {
  let price = priceWithAddOns ? Number(priceWithAddOns) : Number(itemRefPrice);
  let cost = Number(quantity) * price;

  return [price.toFixed(2), cost.toFixed(2)];
}

export function calculateSetPricesLine({ price = 0, quantity = 0 }) {
  let itemPrice = Number(price);
  let cost = Number(quantity) * Number(price);

  return [itemPrice.toFixed(2), cost.toFixed(2)];
}

export function getMaterials(jobDescriptions = []) {
  // Will need to alter this to take into account different prices for the same material but with different percentages.
  let materials = jobDescriptions.reduce((acc, { materials = [] }) => {
    acc.push(materials);
    return acc;
  }, []);

  let flattenedMaterials = materials.flat(1);
  return flattenedMaterials;
}

export function getSetPrices(jobDescriptions = []) {
  let setPrices = jobDescriptions.reduce((acc, { setPriceList = [] }) => {
    acc.push(setPriceList);
    return acc;
  }, []);

  let flattenedSetPriceList = setPrices.flat(1);
  return flattenedSetPriceList;
}

export function calculateOpMultiplier(jobDescriptions) {
  //Loop through jobs and create an object of which operatives are present across
  //all jobs. Due to the Microsoft Access limitations, each job description with
  // more than 0 hours should have the same operatives present. Otherwise, the labour
  //total between the app and Access will be different. Default beahviour here is that
  //present object will contain an op if they are present on any job.
  let present = {};
  jobDescriptions.forEach((job) => {
    if (job.hours > 0) {
      for (let opId in job.operatives) {
        present[opId] = job.operatives[opId];
      }
    }
  });

  let multiplier = 0;
  for (let opId in present) {
    multiplier += Number(present[opId]);
  }

  return multiplier;
}

export function formatAddress(timesheet) {
  let address = timesheet.address ? `${timesheet.address}, ` : "";
  let flat = timesheet.flat ? `Flat ${timesheet.flat} ` : "";
  let unit = timesheet.unit ? `Unit ${timesheet.unit} ` : "";
  let addressLine = `${address}${flat}${unit}`;

  // Similar to below function. Could put into same function and return short or long format
  // let address = ts.address ? `${ts.address}, ` : "";
  // let address2 = ts.address2 ? `${ts.address2}, ` : "";
  // let flat = ts.flat ? `Flat ${ts.flat}, ` : "";
  // let unit = ts.unit ? `Unit ${ts.unit}, ` : "";
  // let city = ts.city ? `${ts.city}, ` : "";
  // let postcode = ts.postcode ? `${ts.postcode}` : "";

  // let formattedLocation = `${address}${address2}${flat}${unit}${city}${postcode}`;
  // return formattedLocation;

  return addressLine;
}

// function getInvoiceRate(jobDescriptions) {
//   // let rate = 0;
//   if (jobDescriptions.length > 0) {
//     let rate = jobDescriptions.find((jd) => {
//       if (jd.ratePerHour) {
//         return true;
//       }
//       return false;
//     });

//     return rate?.ratePerHour ?? 0;
//   } else {
//     return 0.0;
//   }
// }

// function formatHours(jobDescriptions) {
//   let hours = jobDescriptions.reduce((total, { hours = 0 }) => {
//     return total + Number(hours);
//   }, 0);

//   return hours;
// }

export function removeCardFees(jobDescriptions = []) {
  if (!jobDescriptions) {
    return [];
  }

  // Loop over jobdescriptions and remove any setPrice items which contain the term Card Fee
  jobDescriptions = jobDescriptions.map((jd) => {
    let newSetPriceList = [];
    if (jd?.setPriceList) {
      newSetPriceList = jd.setPriceList.filter((setPrice) => !setPrice?.name.includes("Card Fee"));
    }

    return { ...jd, setPriceList: newSetPriceList };
  });

  return jobDescriptions;
}

export function getFirstName(name = "") {
  if (!name) return "";

  let splitName = name.split(" ");
  return splitName[0];
}
